import { deleteMessageTemplate } from "@api";
import {
    Button,
    Modal
} from "@components";
import { useState } from "react";

const DeleteTemplate = ({ isOpen, onClose, onComplete, templateId }) => {

  const [submitting, setSubmitting] = useState(false);

  const onDelete = async () => {
    setSubmitting(true);
    await deleteMessageTemplate(templateId);

    if (onComplete) {
      await onComplete();
    }
    setSubmitting(false);
    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete message template">
      <p className="p-4">Are you sure you want to delete this template? This action cannot be undone.</p>
      <div className="p-4 flex gap-2 justify-end">
        <Button submitting={submitting} onClick={() => onClose()}  color="secondary">Back</Button>
        <Button submitting={submitting} onClick={() => onDelete()}  color="danger">Delete template</Button>
      </div>
    </Modal>
  );
}

export default DeleteTemplate;